/* eslint-disable no-unused-vars */
// eslint-disable-next-line max-len
import cashIcon from "../assests/images/cashIcon.svg";
import accountBookingIcon from "../assests/images/AccountBookingsvg.svg";
import viewBookingIcon from "../assests/images/viewBookingIcon.svg";
import master_setting from "../assests/images/master-setting.svg";
import message_alerts from "../assests/images/message-alerts.svg";
import onboarding_setting from "../assests/images/onboarding-setting.svg";
import configurationIcon from "../assests/images/SVG/configure-setting.svg";
import hub_in_scan from "../assests/images/SVG/hub-in-scan.svg";
import hub_inbound from "../assests/images/SVG/hub-inbound.svg";
import last_mile_icon from "../assests/images/lastMileLogo.svg";
import QRScanner from "../assests/images/QRScanner.svg";
import audit from "../assests/images/SVG/audit-dash.svg";
import report from "../assests/images/SVG/report-img.svg";
import support_contact from "../assests/images/SVG/contact-support.svg";
import constants from "../constants/constants";
import extend from "../assests/images/extentEway.svg";
import trip_scheduler from "../assests/images/trip-scheduler.svg";

import product from "../assests/images/stationaryProduct.svg";
import product_request from "../assests/images/product-request.svg";
import my_order from "../assests/images/my-order.svg";
import create_trip from "../assests/images/middleMile/create-trip.svg";
//import create_trip from "../../../assests/images/middleMile/create-trip.svg";
import client_approval from "../assests/images/SVG/client_approval.svg";
import middle_mile_tat from "../assests/images/master/middle-mile-tat.svg";
import route from "../assests/images/master/route.svg";
const { ROLES } = constants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_HOMARKETING,
  ROLE_ZONALHEAD,
  ROLE_ZONALOPERATOR,
  ROLE_RM,
  ROLE_FUNCTIONALHEAD,
  ROLE_MD,
  ROLE_CENTRALOPERATOR,
  ROLE_BOOKINGAUDITONLY,
  ROLE_HUBOPERATOR,
  DEVELOPER,
  CUSTOMER_DELIGHT_EXECUTIVE,
  ROLE_CSO,
  ROLE_HOCRM
} = ROLES;

export const dashboardMenuList = [
  {
    icon: hub_inbound,
    title: "Hub Outbound",
    id: "middle-mile",
    additionalClass: "",
    route: "/middle-mile",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: hub_in_scan,
    title: "Hub Inbound",
    id: "hub-in-scan",
    additionalClass: "",
    route: "/hub-in-scan",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: create_trip,
    title: "Create & Print LCR",
    id: "create-view-trip",
    additionalClass: "",
    route: "/lcr-generation",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: extend,
    title: "Extend E-way",
    id: "e-way",
    additionalClass: "",
    route: "/extend-eway",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    icon: report,
    title: "Reports",
    id: "report",
    additionalClass: "",
    route: "/reports",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, CUSTOMER_DELIGHT_EXECUTIVE, ROLE_HOCRM],
  },
  {
    icon: audit,
    title: "Audit",
    id: "view-audit",
    additionalClass: "",
    route: "/manifest-audit",
    role: [HO_ADMIN, HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    icon: configurationIcon,
    title: "Config Guide",
    id: "configuration-guide",
    additionalClass: "",
    route: "/configuration-guide",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    icon: master_setting,
    title: "Master Setting",
    id: "master-setting",
    additionalClass: "",
    route: "/masters",
    role: [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD,
      ROLE_ZONALHEAD,
      ROLE_ZONALOPERATOR,
      ROLE_RM,
      ROLE_MD,
      ROLE_CENTRALOPERATOR,
      ROLE_BOOKINGAUDITONLY,
      ROLE_HUBOPERATOR,
      CP_ADMIN,
      ROLE_HOMARKETING,
      ROLE_CSO,
      ROLE_HOCRM,
    ],
  },
  {
    icon: onboarding_setting,
    title: "Onboard Setting",
    id: "onboarding-settings",
    additionalClass: "",
    route: "/onboarding-settings",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    icon: product,
    title: "Training Videos",
    id: "training-videos",
    additionalClass: "",
    route: "/training-videos",
    //all roles
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
  },
  {
    icon: client_approval,
    title: "Approvals",
    id: "approvals",
    additionalClass: "",
    route: "/approvals-settings",
    //all roles
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    icon: report,
    id: "director-dashboard",
    title: "Director Dashboard",
    additionalClass: "",
    route: "/director-dashboard",
    role: [ROLE_MD],
  },
  {
    icon: message_alerts,
    title: "Message & Alert",
    id: "messageAlert",
    additionalClass: "",
    route: "/message-and-alerts",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    icon: report,
    id: "director-dashboard",
    title: "Director Dashboard new",
    additionalClass: "",
    route: "/director-dashboardNew",
    role: [ROLE_MD],
  },
  //mcn
  {
    icon: report,
    id: "MCN",
    title: "MCN",
    additionalClass: "",
    route: "/mcn",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },

  {
    icon: route,
    title: "vehicle route master",
    additionalClass: "",
    route: "/hub-route-configuration",
    role: [ROLE_MD, HO_ADMIN, ROLE_RM, ROLE_ZONALOPERATOR, ROLE_ZONALHEAD, ROLE_FUNCTIONALHEAD],
  },
  {
    icon: middle_mile_tat,
    title: "Shipment Routes",
    additionalClass: "",
    route: "/route-configuration?type=SURFACE",
    role: [ROLE_MD, HO_ADMIN, ROLE_RM, ROLE_ZONALOPERATOR, ROLE_ZONALHEAD, ROLE_FUNCTIONALHEAD,],
  },
  {
    icon: report,
    title: "Control Tower Reports",
    id: "control-tower-reports",
    additionalClass: "",
    route: "/control-tower-reports",
    role: [ROLE_CSO],
  },
  {
    icon: report,
    title: "Non-FT Premium Bookings Report",
    id: "non-ft-premium-bookings-report",
    additionalClass: "",
    route: "/non-ft-premium-bookings-report",
    role: [ROLE_CSO,],
  },
  {
    icon: report,
    title: "Central Ops Dashboard",
    id: "central-ops-dashboard",
    additionalClass: "",
    route: "/central-ops-dashboard",
    role: [ROLE_FUNCTIONALHEAD],
  },
  {
    icon: support_contact,
    id: "support-and-contact",
    title: "Escalation Matrix",
    additionalClass: "",
    route: "/support-and-contact",
    role: [HO_ADMIN, ROLE_CENTRALOPERATOR, DEVELOPER],
  },

  // {
  //   icon: cashIcon,
  //   title: "Retail Booking",
  //   id: "cash-booking",
  //   additionalClass: "",
  //   route: "/retail-booking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: accountBookingIcon,
  //   title: "Credit Booking",
  //   id: "account-booking",
  //   additionalClass: "",
  //   route: "/credit-booking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: viewBookingIcon,
  //   title: "View Booking",
  //   id: "view-booking",
  //   additionalClass: "",
  //   route: "/viewBooking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: last_mile_icon,
  //   title: "Last Mile Ops",
  //   id: "last-mile-operations",
  //   additionalClass: "",
  //   route: "/last-mile-operations",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: QRScanner,
  //   title: "Vehicle Check-In",
  //   id: "view-audit",
  //   additionalClass: "",
  //   route: null,
  //   role: [HUB_ADMIN],
  // },


  // {
  //   icon: trip_scheduler,
  //   title: "Trip Scheduler",
  //   id: "trip-scheduler",
  //   additionalClass: "",
  //   route: "/trip-scheduler",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   icon: product,
  //   title: "Products",
  //   id: "stationary-product",
  //   additionalClass: "",
  //   route: "/stationery",
  //   role: [HO_ADMIN,DEVELOPER],
  // },

  // {
  //   icon: product,
  //   title: "Request Products",
  //   id: "stationery",
  //   additionalClass: "",
  //   route: "/product-list",
  //   role: [CP_ADMIN, HUB_ADMIN,DEVELOPER],
  // },
  // {
  //   icon: my_order,
  //   title: "My Orders",
  //   id: "my-order",
  //   additionalClass: "",
  //   route: "/order-history",
  //   role: [CP_ADMIN, HUB_ADMIN,DEVELOPER],
  // },
  //log
  // {
  //   icon: product,
  //   title: "API Log",
  //   id: "api-log",
  //   additionalClass: "",
  //   route: "/api-log",
  //   role: [HO_ADMIN,DEVELOPER],
  // },

];
